// coupon-alert-multicanal-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "A URL já é o destino e o segredo — não precisa de template nem de contatos. Cada webhook recebe uma cópia.": "La URL ya es el destino y el secreto — no necesita plantilla ni contactos. Cada webhook recibe una copia.",
    "Adicionar webhook": "Agregar webhook",
    "Escolha ao menos um canal para ativar os envios.": "Elija al menos un canal para activar los envíos.",
    "Informe ao menos um webhook do Discord para ativar esse canal.": "Ingrese al menos un webhook de Discord para activar ese canal.",
    "Nenhum webhook — o canal Discord não envia nada.": "Ningún webhook — el canal Discord no envía nada.",
    "Pode ligar os dois: cada canal recebe uma cópia do mesmo aviso. Vale para todos os integradores.": "Puede activar los dos: cada canal recibe una copia del mismo aviso. Vale para todos los integradores.",
    "Remover webhook": "Quitar webhook",
    "Webhook %{arg1}": "Webhook %{arg1}",
    "Webhooks do Discord": "Webhooks de Discord",
};

export default catalogo;
